import React from "react"

export default ({ children }) => (
  <section className="text-secondary flex-1 w-full h-screen max-w-xl px-4 py-8 mx-auto md:px-8 md:py-16 ">
    {children}
  </section>
)
